module.exports = __webpack_public_path__ + "static/media/sourcesanspro-regular-webfont.d8ab7c53.eot";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/sourcesanspro-regular-webfont.eot
// module id = 270
// module chunks = 0